import { kROUser } from "../../constants";
import { enumWidgetType } from "./widgetTypes";

export const OnRampWidget = {
  type: enumWidgetType.onramp,

  // eslint-disable-next-line no-unused-vars
  Load(widgetConfig, context) {
    const { wsMgr } = context;
    const userinfo = wsMgr.GetUserInfo();

    if (userinfo.GetUserRole() === kROUser) {
      return false;
    }

    return true;
  }
};
